import React from 'react';
import { useMediaQuery } from '@mui/material';
import { StyledRoot, StyledDrawer, StyledSidebar } from './Sidebar.styles';
import SidebarHeader from './SidebarHeader';
import SidebarContent from './SidebarContent';
import { useTheme } from '@mui/material/styles';

const Sidebar = ({ mobileOpen, handleDrawerToggle, container }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Detect mobile screens

	const handleMobileItemClick = () => {
		if (mobileOpen) {
			handleDrawerToggle();
		}
	};

	const sidebarContent = (
		<StyledSidebar>
			<SidebarHeader />
			<SidebarContent onMobileItemClick={handleMobileItemClick} />
		</StyledSidebar>
	);

	return (
		<StyledRoot>
			{/* Mobile Sidebar (Temporary Drawer) */}
			{isMobile ? (
				<StyledDrawer
					container={container}
					variant="temporary"
					anchor="left"
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{ keepMounted: true }} // Improve mobile performance
				>
					{sidebarContent}
				</StyledDrawer>
			) : (
				/* Desktop Sidebar (Permanent) */
				<StyledDrawer variant="permanent" open>
					{sidebarContent}
				</StyledDrawer>
			)}
		</StyledRoot>
	);
};

export default Sidebar;
